import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";

export default function EditLotDialog({ lot, onClose, onSaved }) {
  const [precio, setPrecio] = useState("");
  const [area, setArea] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (lot) {
      setPrecio(String(lot.precio || lot.price || ""));
      setArea(String(lot.area || lot.size || ""));
      setDescription(lot.description || "");
    }
  }, [lot]);

  if (!lot) return null;

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch(`/lots/${lot.id}`, { precio: Number(precio), area: Number(area), description });
      toast.success(`Lote ${lot.id} actualizado`);
      onSaved();
    } catch (err) {
      toast.error("Error", { description: formatApiError(err) });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!lot} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Editar lote {lot.id}</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div><Label htmlFor="precio">Precio (MXN)</Label><Input id="precio" type="number" required value={precio} onChange={(e) => setPrecio(e.target.value)} /></div>
          <div><Label htmlFor="area">Área (m²)</Label><Input id="area" type="number" step="0.01" required value={area} onChange={(e) => setArea(e.target.value)} /></div>
          <div><Label htmlFor="description">Descripción</Label><Textarea id="description" rows={3} value={description} onChange={(e) => setDescription(e.target.value)} /></div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
            <Button type="submit" className="bg-slate-900 hover:bg-slate-800" disabled={saving}>{saving ? "Guardando…" : "Guardar"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}